import styled from 'styled-components';

const Caption = styled.span`
  margin: 0px;
  bottom: 0;
  font-weight: 400;
  display: ${p => (p.display ? p.display : 'block')};
  color: ${p => (p.color ? p.color : '#000')};
  font-size: ${p => (p.style.fontSize ? p.style.fontSize : '13px')};
`;

Caption.defaultProps = {
  style: {}, // TODO: figure out proper way to pass in additional style prop to styled-component wrapper
};

export default Caption;



// WEBPACK FOOTER //
// ./src/components/text/Caption/index.js